import { Navigate, Outlet, useLocation } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { vaildateAuthentication } from "./AuthUtils";
import { useEffect } from "react";
import { authStore } from "../../store/AuthStore";

const ProtectedRoute = observer(() => {
    const idToken = authStore.getIdToken();
    const location = useLocation();
    
    useEffect(() => {
        if (idToken) {
            vaildateAuthentication();
        }
    }, [location.pathname]);
    
    return idToken ? <Outlet /> : <Navigate to="/login" />;
});

export default ProtectedRoute;